var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{attrs:{"id":"app","data-authenticated":_vm.$store.getters.authenticated}},[_c('LayoutPrimary'),_c('ChalkyUtilityAlertPrompt',{ref:"alertPrompt"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }